import { cn } from '../cn';

import type { HTMLAttributes } from 'react';

export type BadgeTone = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

const TONE: Record<BadgeTone, string> = {
  info: 'bg-surface-static-info-default text-content-info-default border-border-info-default',
  success: 'bg-surface-static-success-default text-content-success-default border-border-success-default',
  warning: 'bg-surface-static-warning-default text-content-warning-default border-border-warning-default',
  danger: 'bg-surface-static-danger-default text-content-danger-default border-border-danger-default',
  neutral: 'bg-surface-static-neutral-default text-content-subdued border-border-subdued',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone | undefined;
}

/** A status pill. For a removable chip use `Tag`. */
export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 font-display text-xs leading-[18px] font-semibold',
        TONE[tone],
        className,
      )}
      {...rest}
    />
  );
}
